import type { StoreActionApi } from 'react-sweet-state';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { TEAM_NAME } from '../../../../common/constants';
import { fetchCategories as fetchCategoriesService } from '../../../../services/fetch-categories';
import type { State } from '../../types';

export const fetchCategories =
	(projectId: number, analyticsEvent: UIAnalyticsEvent, activationId: string) =>
	async ({ setState, getState }: StoreActionApi<State>) => {
		const initialState = { ...getState() };
		setState({
			...getState(),
			categoriesData: { ...initialState.categoriesData, isLoading: true },
		});
		try {
			const { categories, categoriesSupported } = await fetchCategoriesService(
				projectId,
				activationId,
			);
			setState({
				...getState(),
				categoriesData: {
					categories,
					isCategoriesSupported: categoriesSupported,
					isLoading: false,
					error: null,
				},
			});
			fireTrackAnalytics(analyticsEvent, 'onFetchCategories success', {
				projectId,
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			setState({
				...getState(),
				categoriesData: {
					...initialState.categoriesData,
					isLoading: false,
					error,
				},
			});
			fireErrorAnalytics({
				meta: {
					id: 'onFetchCategoriesFailure',
					packageName: 'jiraServicedeskKnowledgeCommon',
					teamName: TEAM_NAME,
				},
				error,
			});
		}
	};
